<script>
import DatePicker from "vue2-datepicker"; // add DatePicker
import Multiselect from "vue-multiselect"; // add Multiselect
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import { fileSize, fileType } from "../../../helpers/validators_files";
import certificate from "../../../helpers/list/certificate";
import marital_status from "../../../helpers/list/marital_status";
import city from "../../../helpers/list/city";
import gender from "../../../helpers/list/gender";
import missing_martyr from "../../../helpers/list/missing_martyr";
import government_grants from "../../../helpers/list/government_grants";

export default {
  components: { DatePicker, Multiselect },
  props: {
    sacrificer: {
      type: Object,
      default(){
        return null
      }
    }
  },

  data() {
    return {
      birth_date: "",
      marital_status_id: "",
      certificate_id: "",
      gender_id: "",
      city_id: "",
      retirement_number: "",
      dept: "",
      date_marty: "",
      place_marty: "",
      missing_martyr_id: "",
      government_grants_id: [],
      attachment_martyrdom: "",

      //lists
      list_certificate: certificate,
      list_marital_status: marital_status,
      list_city: city,
      list_gender: gender,
      list_missing_martyr: missing_martyr,
      list_government_grants: government_grants.map((x) => {
        return {
          id: x.id,
          name: x.name,
          $isDisabled: false,
        };
      }),
    };
  },
  validations: {
    birth_date: {
      required,
      maxValue(val) {
        if (val != null) {
          val = val.split("-");
          const d = new Date();
          return (
            new Date(val[2], val[1], val[0]) <=
            new Date(d.getFullYear() - 5, d.getMonth() + 1, d.getDate())
          );
        }
        return true;
      },
    },
    dept: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(50),
    },
    marital_status_id: { required },
    certificate_id: { required },
    gender_id: { required },
    city_id: { required },
    date_marty: {
      required,
      maxValue(val) {
        if (val != null) {
          val = val.split("-");
          let date = val[2] + "-" + val[1] + "-" + val[0];
          return date <= new Date().toISOString().substring(0, 10);
        }
        return true;
      },
    },
    place_marty: { required, minLength: minLength(2), maxLength: maxLength(50) },
    retirement_number: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(10),
    },
    missing_martyr_id: { required },
    government_grants_id: { required },
    attachment_martyrdom: {
      required,
      fileType: fileType(["application/pdf", "image/jpg", "image/jpeg", "image/png"]),
      fileSize: fileSize(1024 * 1024 * 5),
    },
    form: [
      "birth_date",
      "marital_status_id",
      "certificate_id",
      "gender_id",
      "city_id",
      "retirement_number",
      "dept",
      "date_marty",
      "place_marty",
      "missing_martyr_id",
      "government_grants_id",
      "attachment_martyrdom",
    ],
  },
  methods: {
    // validate
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit("on-validate", this.$data, isValid);
      return isValid;
    },

    // multiselect
    onChange() {
      for (let index = 0; index < this.list_government_grants.length; index++) {
        this.list_government_grants[index]["$isDisabled"] = false;
      }
      if (this.government_grants_id.findIndex((o) => o.id == 10) != -1) {
        for (let index = 0; index < this.list_government_grants.length; index++) {
          if (this.list_government_grants[index].id != 10) {
            this.list_government_grants[index]["$isDisabled"] = true;
          }
        }
        this.government_grants_id = this.government_grants_id.filter((o) => o.id == 10);
      }
    },
  },
};
</script>

<template>
  <!-- start page title -->
  <div>
    <!-- شهيد -->
    <div class="row">
      <!-- title -->
      <hr class="hr-title" />
      <div class="break-title"><h5 class="mb-4">المعلومات الاساسية للشهيد</h5></div>
      <b-form-group class="col-md-3 mb-3" label="الاسم : " label-for="name1">
        <b-form-input
          id="name1"
          type="text"
          placeholder="ادخل الاسم"
          v-model="sacrificer.sacrificer.name1"
          :disabled="true"
        ></b-form-input>
      </b-form-group>
      <b-form-group class="col-md-3 mb-3" label="اسم الاب : " label-for="name2">
        <b-form-input
          id="name2"
          type="text"
          placeholder="ادخل اسم الاب"
          v-model="sacrificer.sacrificer.name2"
          :disabled="true"
        ></b-form-input>
      </b-form-group>
      <b-form-group class="col-md-3 mb-3" label="اسم الجد : " label-for="name3">
        <b-form-input
          id="name3"
          type="text"
          placeholder="ادخل اسم الجد"
          v-model="sacrificer.sacrificer.name3"
          :disabled="true"
        ></b-form-input>
      </b-form-group>
      <b-form-group class="col-md-3 mb-3" label="اسم اب الجد : " label-for="name4">
        <b-form-input
          id="name4"
          type="text"
          placeholder="ادخل اسم اب الجد"
          v-model="sacrificer.sacrificer.name4"
          :disabled="true"
        ></b-form-input>
      </b-form-group>
    </div>
    <div class="row">
      <b-form-group class="col-md-3 mb-3" label=" اللقب : " label-for="family_name">
        <b-form-input
          id="family_name"
          type="text"
          placeholder="ادخل اللقب"
          v-model="sacrificer.sacrificer.family_name"
          :disabled="true"
        ></b-form-input>
      </b-form-group>
      <b-form-group
        class="col-md-3 mb-3"
        label="اسم الام الثلاثي : "
        label-for="mother_name"
      >
        <b-form-input
          id="mother_name"
          type="text"
          placeholder="ادخل اسم الام الثلاثي"
          v-model="sacrificer.sacrificer.mother_name"
          :disabled="true"
        ></b-form-input>
      </b-form-group>
      <b-form-group class="col-md-3 mb-3" label="تاريخ التولد : " label-for="birth_date">
        <date-picker
          id="birth_date"
          type="date"
          lang="ar"
          value-type="DD-MM-YYYY"
          format="DD-MM-YYYY"
          placeholder="اختر تاريخ التولد"
          v-model="birth_date"
          :class="{ 'is-invalid': $v.birth_date.$error }"
        ></date-picker>
        <div v-if="$v.birth_date.$error" class="invalid-feedback">
          <span v-if="!$v.birth_date.required">هذا الحقل الزامي </span>
          <span v-if="!$v.birth_date.maxValue"
            >يجب ان يكون عمر الشهيد اكبر او يساوي 5 سنوات
          </span>
        </div>
      </b-form-group>
      <b-form-group class="col-md-3 mb-3" label=" الجنس : " label-for="gender_id">
        <select
          class="form-control"
          id="gender_id"
          v-model="gender_id"
          :class="{ 'is-invalid': $v.gender_id.$error }"
        >
          <option value="">اختر الجنس</option>
          <option v-for="gender in list_gender" :value="gender.id" :key="gender.id">
            {{ gender.name }}
          </option>
        </select>
        <div v-if="$v.gender_id.$error" class="invalid-feedback">
          <span v-if="!$v.gender_id.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>
    </div>
    <div class="row">
      <b-form-group
        class="col-md-3 mb-3"
        label=" الحالة الاجتماعية : "
        label-for="marital_status_id"
      >
        <select
          class="form-control"
          id="marital_status_id"
          v-model="marital_status_id"
          :class="{ 'is-invalid': $v.marital_status_id.$error }"
        >
          <option value="">اختر الحالة الاجتماعية</option>
          <option
            v-for="marital_status in list_marital_status"
            :value="marital_status.id"
            :key="marital_status.id"
          >
            {{ marital_status.name }}
          </option>
        </select>
        <div v-if="$v.marital_status_id.$error" class="invalid-feedback">
          <span v-if="!$v.marital_status_id.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>
      <b-form-group
        class="col-md-3 mb-3"
        label=" التحصيل الدراسي : "
        label-for="certificate_id"
      >
        <select
          class="form-control"
          id="certificate_id"
          v-model="certificate_id"
          :class="{ 'is-invalid': $v.certificate_id.$error }"
        >
          <option value="">اختر التحصيل الدراسي</option>
          <option
            v-for="certificate in list_certificate"
            :value="certificate.id"
            :key="certificate.id"
          >
            {{ certificate.name }}
          </option>
        </select>
        <div v-if="$v.certificate_id.$error" class="invalid-feedback">
          <span v-if="!$v.certificate_id.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>
      <b-form-group class="col-md-3 mb-3" label=" التشكيل : " label-for="dept">
        <b-form-input
          id="dept"
          type="text"
          placeholder="ادخل التشكيل "
          v-model="dept"
          :class="{ 'is-invalid': $v.dept.$error }"
        ></b-form-input>
        <div v-if="$v.dept.$error" class="invalid-feedback">
          <span v-if="!$v.dept.required">هذا الحقل الزامي</span>
          <span v-if="!$v.dept.minLength">يجب أن يتكون التشكيل من حرفين على الأقل</span>
          <span v-if="!$v.dept.maxLength">يجب أن يتكون التشكيل من 50 حرف على الاكثر</span>
        </div>
      </b-form-group>
      <b-form-group
        class="col-md-3 mb-3"
        label=" الرقم التقاعدي : "
        label-for="retirement_number"
      >
        <b-form-input
          id="retirement_number"
          type="number"
          placeholder="ادخل الرقم التقاعدي"
          v-model="retirement_number"
          :class="{ 'is-invalid': $v.retirement_number.$error }"
        ></b-form-input>
        <div v-if="$v.retirement_number.$error" class="invalid-feedback">
          <span v-if="!$v.retirement_number.required">هذا الحقل الزامي</span>
          <span v-if="!$v.retirement_number.minLength"
            >يجب أن يتكون الرقم التقاعدي من 6 ارقام على الأقل</span
          >
          <span v-if="!$v.retirement_number.maxLength"
            >يجب أن يتكون الرقم التقاعدي من 10 ارقام على الاكثر</span
          >
        </div>
      </b-form-group>
    </div>
    <div class="row">
      <b-form-group
        class="col-md-4 mb-3"
        label=" محافظة سكن الشهيد  : "
        label-for="city_id"
      >
        <select
          class="form-control"
          id="city_id"
          v-model="city_id"
          :class="{ 'is-invalid': $v.city_id.$error }"
        >
          <option value="">اختر محافظة السكن</option>
          <option v-for="city in list_city" :value="city.id" :key="city.id">
            {{ city.name }}
          </option>
        </select>
        <div v-if="$v.city_id.$error" class="invalid-feedback">
          <span v-if="!$v.city_id.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>
      <b-form-group
        class="col-md-4 mb-3"
        label="تاريخ الاستشهاد : "
        label-for="date_marty"
      >
        <date-picker
          id="date_marty"
          type="date"
          lang="ar"
          value-type="DD-MM-YYYY"
          format="DD-MM-YYYY"
          placeholder="اختر تاريخ الاستشهاد"
          v-model="date_marty"
          :class="{
            'is-invalid': $v.date_marty.$error,
          }"
        ></date-picker>
        <div v-if="$v.date_marty.$error" class="invalid-feedback">
          <span v-if="!$v.date_marty.required">هذا الحقل الزامي </span>
          <span v-if="!$v.date_marty.maxValue"
            >يجب ان لا يتجاوز تاريخ الاستشهاد تاريخ اليوم
          </span>
        </div>
      </b-form-group>
      <b-form-group class="col-md-4 mb-3" label=" محل الحادث : " label-for="place_marty">
        <b-form-input
          id="place_marty"
          type="text"
          placeholder="ادخل محل الحادث"
          v-model="place_marty"
          :class="{ 'is-invalid': $v.place_marty.$error }"
        ></b-form-input>
        <div v-if="$v.place_marty.$error" class="invalid-feedback">
          <span v-if="!$v.place_marty.required">هذا الحقل الزامي</span>
          <span v-if="!$v.place_marty.minLength"
            >يجب أن يتكون محل الحادث من حرفين على الأقل</span
          >
          <span v-if="!$v.place_marty.maxLength"
            >يجب أن يتكون محل الحادث من 50 حرف على الاكثر</span
          >
        </div>
      </b-form-group>
    </div>
    <div class="row">
      <b-form-group
        class="col-md-6 mb-3"
        label=" هل الشهيد مفقود الاثر : "
        label-for="missing_martyr_id"
      >
        <select
          class="form-control"
          id="missing_martyr_id"
          v-model="missing_martyr_id"
          :class="{ 'is-invalid': $v.missing_martyr_id.$error }"
        >
          <option value="">اختر الاجابة</option>
          <option
            v-for="missing_martyr in list_missing_martyr"
            :value="missing_martyr.id"
            :key="missing_martyr.id"
          >
            {{ missing_martyr.name }}
          </option>
        </select>
        <div v-if="$v.missing_martyr_id.$error" class="invalid-feedback">
          <span v-if="!$v.missing_martyr_id.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>
      <b-form-group
        class="col-md-6 mb-3"
        label=" هل انت مستفيد من منح حكومية  : "
        label-for="government_grants_id"
      >
        <multiselect
          id="government_grants_id"
          select-label="حدد الاختيار"
          placeholder="اختر المنح الحكومية"
          deselect-label="اظغط هنا لمسح الاختيار"
          selected-label="تم اختياره"
          :options="list_government_grants"
          track-by="id"
          label="name"
          :close-on-select="false"
          :clear-on-select="false"
          :multiple="true"
          v-model="government_grants_id"
          @input="onChange"
          :class="{ 'is-invalid': $v.government_grants_id.$error }"
        >
          <template slot="singleLabel" slot-scope="{ option }"
            ><strong>{{ option.name }}</strong> is written in<strong>
              {{ option.name }}</strong
            ></template
          >
        </multiselect>
        <div v-if="$v.government_grants_id.$error" class="invalid-feedback">
          <span v-if="!$v.government_grants_id.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>
    </div>

    <hr class="hr-title" />
    <div class="break-title">
      <h5 class="mb-4">مرفق تأييد الاستشهاد</h5>
    </div>

    <div class="row">
      <div class="col-md-12 mb-3">
        <ul class="li-attachments">
          <li>مرفق تأييد الاستشهاد و شهادة الوفاة .</li>
          <li>
            يجب ان يكون المرفق بأحد الصيغ التالية ( pdf .jpg .jpeg .png. ) وبحجم لا يتجاوز
            ( 5MB ) .
          </li>
        </ul>
        <b-form-group
          class=""
          label=" مرفق تأييد الاستشهاد :"
          label-for="attachment_martyrdom"
        >
          <div class="custom_file">
            <b-form-file
              id="attachment_martyrdom"
              class=""
              placeholder="اختر المرفق"
              accept=".pdf,.jpg,.jpeg,.png"
              v-model="attachment_martyrdom"
              :class="{ 'is-invalid': $v.attachment_martyrdom.$error }"
            ></b-form-file>
            <div v-if="$v.attachment_martyrdom.$error" class="invalid-feedback">
              <span v-if="!$v.attachment_martyrdom.required">هذا الحقل الزامي </span>
              <span v-if="!$v.attachment_martyrdom.fileSize"
                >يجب ان لا يتجاوز حجم الملف 5MB
              </span>
              <span v-if="!$v.attachment_martyrdom.fileType"
                >يجب ان يكون نوع الملف .pdf,.jpg,.jpeg,.png
              </span>
            </div>
          </div>
        </b-form-group>
      </div>
    </div>
  </div>
  <!-- end page title -->
</template>
